import { observer } from "mobx-react-lite";
import { applyTextFieldStyle, EXTERNAL_API_FORM_REQUIRED_LABEL, useExternalAPIWizardStore, WIDTH_SPACE, API_KEY_NAME, API_KEY, API_KEY_ADD_TO } from "./ExternalAPIWizardStore";
import { useLocale } from "designSystem/locale";
import { FlexColumn, TextField, Text, SingleSelect, FormControlLabel } from "designSystem/index";
import React from "react";

export const APIKeyTypeSetupForm = observer(() => {
	const locale = useLocale();
	const store = useExternalAPIWizardStore();
	const {
		apiKey,
		apiKeyError,
		apiKeyErrorHelperTextRes, 
		isApiKeyHidden,
		apiKeyName,
		apiKeyNameError,
		apiKeyNameErrorHelperTextRes, 
		apiKeyAddToComponentItem,
		apiAddToError, 
		apiAddToErrorHelperTextRes, 
		apiKeyAddToOptions,
		hideApiKey,
		setAPIKey,
		setAPIKeyName,
		setAPIAddTo,
		showApiKey,
		isReadonlyField,
	} = store;

	return (
		<FlexColumn width="100%">
			<FormControlLabel
				control={(
					<TextField
						autoFocus
						defaultValue={apiKeyName}
						disabled={isReadonlyField(API_KEY_NAME)}
						error={apiKeyNameError}
						helperTextRes={apiKeyNameErrorHelperTextRes}
						onChange={setAPIKeyName}
						placeholder={locale.resource("APIKeyCredentialKeyNameFieldPlaceholder")}
						sx={applyTextFieldStyle("75%")}
					/>
				)}
				label={<Text bold text={locale.attributeResource("APIKeyCredentials", "KeyName")} />}
				labelPlacement="start"
				required
				sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
			/>
			<FormControlLabel
				control={(
					<TextField
						disabled={isReadonlyField(API_KEY)}
						error={apiKeyError}
						fullWidth
						helperTextRes={apiKeyErrorHelperTextRes}
						onBlur={hideApiKey}
						onChange={setAPIKey}
						onFocus={showApiKey}
						placeholderRes="APIKeyCredentialKeyFieldPlaceholder"
						sx={applyTextFieldStyle("75%")}
						value={isApiKeyHidden ? "\u{2022}".repeat(200) : apiKey}
					/>
				)}
				label={<Text bold text={locale.attributeResource("APIKeyCredentials", "Key")} />}
				labelPlacement="start"
				required
				sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
			/>
			<FormControlLabel
				control={(
					<SingleSelect
						disabled={isReadonlyField(API_KEY_ADD_TO)}
						helperTextRes={apiAddToErrorHelperTextRes}
						invalid={apiAddToError}
						onChange={setAPIAddTo}
						options={apiKeyAddToOptions}
						placeHolderRes="APIKeyCredentialAPIKeyAddToFieldPlaceholder"
						required
						sx={applyTextFieldStyle("75%")}
						value={apiKeyAddToComponentItem}
					/>
				)}
				label={<Text bold text={locale.resource("APIKeyCredentialAddToLabel")} />}
				labelPlacement="start"
				required
				sx={{ ...EXTERNAL_API_FORM_REQUIRED_LABEL, ...WIDTH_SPACE }}
			/>
		</FlexColumn>
	);
});
